import { createContext, useEffect, useState } from "react";
import ApiService from "../_services/ApiService";
import { AxiosResponse } from "axios";

export interface TestDetails{
  id: number | string,
  name: string,
  tests: []
}

export const TestAnalysisContext = createContext({
  testDetails: [],
  isLoading: true,
  getTestDetailsByCategoryId: (categoryId: string) : TestDetails | null => ({} as TestDetails),
});

export const TestAnalysisProvider = ({ children }) => {
  const [testDetails, setTestDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchTestDetails = async () => {
    try {
      const response: AxiosResponse<any> = await ApiService.getTestAnalysis();
      setTestDetails(response.data.testDetails);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchTestDetails();
  }, []);

  const getTestDetailsByCategoryId = (categoryId) => {
    // console.log(categoryId);

    const result = testDetails.filter(
      (testDetail) => testDetail.id.toString() === categoryId
    );

    if (result.length) return result[0];

    return null;
  };

  const value = {
    testDetails,
    isLoading,
    getTestDetailsByCategoryId,
  };

  return (
    <TestAnalysisContext.Provider value={value}>
      {children}
    </TestAnalysisContext.Provider>
  );
};
